import { Flex, Table } from 'components';
import { ActiveDot } from 'components/ActiveDot/ActiveDot';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IPlatformUser } from 'types/platformUser';

const CenteredCell = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 100%;
`;

interface Props {
  users: IPlatformUser[];
  showCompany?: boolean;
}

export const PlatformUsersTable: React.FC<Props> = ({ users, showCompany = true }) => {
  const { t } = useTranslation();

  const header = [
    t('platformUsers.tableHeaders.active'),
    t('platformUsers.tableHeaders.email'),
    t('platformUsers.tableHeaders.role'),
    ...(showCompany ? [t('platformUsers.tableHeaders.company')] : [])
  ];

  const data = useMemo(
    () =>
      users.map((user) => ({
        active: (
          <CenteredCell key={`active-${user.id}`}>
            <ActiveDot active={!user.locked_at} />
          </CenteredCell>
        ),
        email: user.email,
        role: t(`platformUsers.roles.${user.role}`, user.role),
        ...(showCompany
          ? { company: user.company_short_name || t('platformUsers.noCompany') }
          : {})
      })),
    [users, showCompany, t]
  );

  return (
    <Table
      header={header}
      data={data}
      sortTable={false}
      leftFixedKeys={[1]}
      centeredColumnKeys={[0]}
    />
  );
};
